import makeStyles from "@material-ui/core/styles/makeStyles";
import colors from "Styles/colors";

const useStyles = makeStyles(theme => ({
  checkmarkWrapper: {
    backgroundColor: theme.palette.success.dark,
    minHeight: 100,
    display: "flex",
    alignItems: "center",
  },
  successText: {
    fontWeight: 1000,
    color: colors.black,
  }
}));

export default useStyles;
